;var Ruler = (function() {

  function minPosition() {
    return 0;
  }

  function maxPosition() {
    var max;
    if (window.innerWidth < 1000) {
      max = Map(window.innerWidth, 320, 1000, 180, 860);
    } else {
      max = 910;
    }
    return max;
  }

  return {
    minPosition: minPosition,
    maxPosition: maxPosition,
  }

})();
